import NetworkApi from '../libs/network/d'
class AuthNetwork {
    private network: NetworkApi

    constructor(network: NetworkApi) {
        this.network = network
    }


    public login = (params: { phoneNumber: string; password: string }) => {
        const data = this.network.postItem<string>('admin/login', params).next(res => {
            this.network.setToken(res)
            return res
        })
        return data.loading()
    }


}
const Auth = (network: NetworkApi) => new AuthNetwork(network);
export default Auth
